"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorage {
    constructor() {
        let storage;
        this._storeAvailable = false;
        this._store = null;
        try {
            storage = window['localStorage'];
            const x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            this._storeAvailable = true;
        }
        catch (e) {
            this._storeAvailable = false;
        }
    }
    get(key) {
        if (this._storeAvailable && this._store !== null) {
            return JSON.parse(this._store.getItem(key));
        }
        return null;
    }
}
exports.localStorage = new LocalStorage();
